import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "../styles/electricity.css"; // import the external CSS
import GlobalLoading from '../components/GlobalLoading';

const ElectricityDetails = () => {
  const { currentUser, fetchElectricityDetails } = useContext(AuthContext);
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const loadTokens = async () => {
      if (!currentUser) {
        setErrorMsg("User not logged in");
        setLoading(false);
        return;
      }

      const result = await fetchElectricityDetails();

      if (result?.error) {
        setErrorMsg(result.error);
      } else {
        setTokens(result);
      }

      setLoading(false);
    };

    loadTokens();
  }, [currentUser]);

  return (
    <div className="electricity-container">
      {loading ? (
        <GlobalLoading />
      ) : errorMsg ? (
        <p className="error-message">{errorMsg}</p>
      ) : tokens.length === 0 ? (
        <p className="empty-message">No tokens found.</p>
      ) : (
        <div className="token-grid">
  {tokens.map((token, idx) => (
    <div key={idx} className="elect-bottom-card">
      <div className="elect-details-row">
        <div className="label">Trans ID</div>
        <div className="value">{token.trans_id}</div>
      </div>
      <div className="elect-details-row">
        <div className="label">Service</div>
        <div className="value">{token.service}</div>
      </div>
      <div className="elect-details-row">
        <div className="label">Meter Number</div>
        <div className="value">{token.meterNumber}</div>
      </div>
      <div className="elect-details-row">
        <div className="label">Token</div>
        <div className="value">{token.token}</div>
      </div>
      <div className="elect-details-row">
        <div className="label">Created</div>
        <div className="value">
          {new Date(token.createdAt).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })},{" "}
          {new Date(token.createdAt).toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })}
        </div>
      </div>
    </div>
  ))}
</div>

      )}
    </div>
  );
};

export default ElectricityDetails;
